function navigationSurf(width) {

    const screen            = $(window).width();
    const nav               = $('#_navigation');
    const mobileConteiner   = $('._js-mobile-nav-container');
    const desktopConteiner  = $('._js-desktop-nav-container');

    if ( screen <= width ) {
        if ( !mobileConteiner.find(nav).length ) {
            mobileConteiner.prepend(nav);
        }
    }
    else {
        if ( !desktopConteiner.find(nav).length ) {
            nav.appendTo(desktopConteiner);
        }
    }

}